module.exports = __webpack_public_path__ + "static/media/calendar-white-add.705cc9c4.svg";